import React, { Component } from 'react';
import { Field } from 'redux-form';

import { LongTextInput } from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Save from '@material-ui/icons/Save';
import Slide from '@material-ui/core/Slide';
import { createStyles, withStyles } from '@material-ui/core/styles';

const styles = createStyles({
  dialog: {
    maxWidth: 1000,
    width: 800
  },
  button: {
    margin: '10px 24px',
    position: 'relative'
  }
});

const transition = (props) => (
  <Slide direction="up" {...props} />
)

type Props = {
  classes: any,
  handleSubmitWithRedirect: any,
  invalid?: boolean,
  redirect: string | boolean,
  saving?: any
};

type StateProps = {
  open: boolean
};

class ConfirmChange extends Component<Props, StateProps> {
  state = {
    open: false,
  };

  handleOpen = () => {
    if (this.props.invalid !== true) {
      this.setState({ open: true });
    } else {
      this.props.handleSubmitWithRedirect(this.props.redirect)();
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClick = e => {
    this.setState({ open: false });
    // copied from react-admin
    if (this.props.saving) {
      // prevent double submission
      e.preventDefault();
    } else {
      // always submit form explicitly regardless of button type
      if (e) {
        e.preventDefault();
      }
      this.props.handleSubmitWithRedirect(this.props.redirect)();
    }
  };

  render() {
    return (
      <span>
        <Button onClick={this.handleOpen} variant="contained" color="primary" className="button">Save</Button>
        <Dialog open={this.state.open} TransitionComponent={transition} classes={{ paper: this.props.classes.dialog }}>
          <DialogTitle>Add a comment about your change</DialogTitle>
          <DialogContent>
            <Field name="comment" source="comment" component={LongTextInput} autoFocus />
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={this.handleClick}>Ok</Button>
          </DialogActions>
        </Dialog>
      </span>
    );
  }
}

export default withStyles(styles)(ConfirmChange);



// WEBPACK FOOTER //
// ./src/views/Common/Dialogs/ConfirmChange.tsx